import { GoogleSheetsSyncPage, SyncType } from '../../components/GoogleSheetsSyncPage/GoogleSheetsSyncPage';
import { PageId } from '../../components/Sidebar/Sidebar';
import defaultSheets from '../../config/default_sheets';

const BuyerVendorSyncPage = () => {
  return (
    <GoogleSheetsSyncPage
      title="Sync Buyer Vendor Data from Google Sheets"
      syncType={SyncType.BuyerVendor}
      pageId={PageId.BuyerVendor}
      defaultSheetUrl={defaultSheets.BuyerVendor.defaultSheetUrl}
      defaultRange={defaultSheets.BuyerVendor.defaultRange}
    />
  );
};

export default BuyerVendorSyncPage;
